<template lang="pug">
Container(@loaded="afterload" :itemId="fileId")
    div(style="height: calc(100vh - 5px); display: flex; justify-content: center; align-items: center; overflow: auto")
        img(v-if="url" :src="url" style="max-width: 100%; max-height: 100%; object-fit: contain")
</template>

<script>
import Container from './Container.vue';
const host = '/api/fs';

export default {
    props: ['fileId'],
    data() {
        return {
            id: '',
            url: null,
        }
    },
    methods: {
        afterload(info) {
            this.id = info.id;
            this.url = `${host}/download/${this.id}?jwt=${this.$api.jwt}`;
        }
    },
    components: {
        Container
    }
}
</script>
